import BackIcon from '../icons/BackIcon'
import IconContainer from '../icons/IconContainer'
import Container from '../basic-components/Container'
import Content from '../basic-components/Content'
import { Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'

export default function UnknownPage({ page, onBackClick }) {
  //console.log(page);
  return (
    <Container>
      <Header>
      <IconContainer>
        <BackIcon onClick={onBackClick}/>
      </IconContainer>
        <HeaderTitle><strong>Unknown Page</strong></HeaderTitle>
        <IconContainer>
        </IconContainer>
      </Header>
      <Content>
        <br/><br/>
        Unknown Page = {page.text}
      </Content>
    </Container>

  );
}
